import * as Yup from 'yup';

export default Yup.object().shape({
  request: Yup.object().shape({
    item_quantity: Yup.number()
      .min(1, 'Provide a rough estimate if you’re not sure yet')
      .required('Provide a rough estimate if you’re not sure yet'),
  }),
});
